var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsBoolean, IsDate, IsNumber, IsOptional, IsString, IsUUID } from 'class-validator';
import { AppointmentStatus } from '../../appointments/enums/appointment-status.enum.js';
/**
 * Adoptable-appointments BFF view (TM-9168 slice 2). One row per existing
 * standalone appointment that a new treatment plan could adopt. The reader
 * already excludes terminal/outcome-recorded/linked appointments — every row
 * is therefore a live candidate. `defaultChecked` carries the conservative
 * pre-check verdict (future-in-window → true).
 */
export class AdoptableAppointmentViewDto {
    appointmentId;
    scheduledStart;
    plannedDuration;
    therapistId;
    therapistDisplayName;
    service;
    status;
    defaultChecked;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], AdoptableAppointmentViewDto.prototype, "appointmentId", void 0);
__decorate([
    IsDate(),
    Expose(),
    __metadata("design:type", Date)
], AdoptableAppointmentViewDto.prototype, "scheduledStart", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], AdoptableAppointmentViewDto.prototype, "plannedDuration", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], AdoptableAppointmentViewDto.prototype, "therapistId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], AdoptableAppointmentViewDto.prototype, "therapistDisplayName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], AdoptableAppointmentViewDto.prototype, "service", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AdoptableAppointmentViewDto.prototype, "status", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], AdoptableAppointmentViewDto.prototype, "defaultChecked", void 0);
//# sourceMappingURL=adoptable-appointment-view.dto.js.map